import * as columnFormatters from "../../components/column-formatters";

export const teamColumn = [
    {
      dataField: "noIndex",
      text: "#",
      sort: true,
      show: true,
      format: {
        style: {
          width: '40px',
          minWidth: '40px',
        },
      },
    },
    {
      dataField: "teamName",
      text: "Team Name",
      sort: true,
      show: true,
    },
    {
      dataField: "playerName",
      text: "Player Name",
      sort: true,
      show: true,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      show: true,
    },
    {
      dataField: "userData",
      text: "Mobile",
      sort: true,
      show: true,
      format: {
        formatter: columnFormatters.TeamColumnFormatter,
      }
    },
    {
      dataField: "acceptedDate",
      text: "Accepted / Rejected Date & Time",
      sort: true,
      show: true,
      format: {
        formatter: columnFormatters.dateTimeFormatCol,
      }
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      show: true,
    },
    {
      dataField: "createdAt",
      text: "Joined Date",
      sort: true,
      show: true,
      format: {
        formatter: columnFormatters.dateFormatCol,
      }
    },
    {
      dataField: "createdAt",
      text: "Joined Time",
      sort: true,
      show: true,
      format: {
        formatter: columnFormatters.timeFormatCol,
      }
    },
    {
      dataField: "isWildCard",
      text: "Wild Card Entry",
      sort: true,
      show: true,
      format: {
        formatter: columnFormatters.YesNoColumnFormatter,
      }
    }
  ];